const buttonVariants = {
    cashOutButton: {
        $extendFromVariant: "primaryMedium",
        root: {
            marginBottom: "$s2",
            color: "$black",
            backgroundColor: "$yellow700",
            cursor: "pointer",
        },
        "root:hover": {
            color: "$black",
            backgroundColor: "$yellow700",
            cursor: "pointer",
        },
        "root:active": {
            color: "$black",
            backgroundColor: "$yellow700",
            cursor: "pointer",
        },
        "root:busy": {
            color: "$black",
            backgroundColor: "$yellow700",
            cursor: "pointer",
        }
    },
    "cashOutButton:Suspended": {
        $extendFromVariant: "primaryMedium",
        root: {
            marginBottom: "$s2",
            color: "$white",
            backgroundColor: "rgba(77, 77, 77, 0.6);",
            opacity: 0.3,
        },
        "root:disabled": {
            backgroundColor: "rgba(77, 77, 77, 0.6);",
            opacity: 0.3,
        },
        "root:active": {
            backgroundColor: "rgba(77, 77, 77, 0.6);",
            opacity: 0.3,
        },
        "root:busy": {
            backgroundColor: "rgba(77, 77, 77, 0.6);",
            opacity: 0.3,
        }
    },
    _bonus: {
        root: {
            paddingTop: "3px",
            paddingRight: "6px",
            paddingBottom: "3px",
            paddingLeft: "6px",
            border: 0,
            borderRadius: "4px",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "10px",
            lineHeight: "14px",
            textTransform: "uppercase",
            cursor: "pointer",
        },
    },
    "betBoost:Active": {
        root: {
            $extendFromVariant: "_bonus",
            color: "$white",
            backgroundColor: "$purple700",
        },
    },
    "ghostLeg:Active": {
        root: {
            $extendFromVariant: "_bonus",
            color: "$white",
            backgroundColor: "$purple700",
            cursor: "default",
        },
    },
    earlyExit: {
        root: {
            $extendFromVariant: "_bonus",
            color: "$black",
            backgroundColor: "#F3601B",
            height: "19px",
            padding: "1px 4px",
            fontSize: "10px",
            lineHeight: "0",
        },
    },
    "earlyExit:Inactive": {
        $extendFromVariant: "earlyExit",
        root: {
            opacity: 0.3,
        }
    },
    "ghostLeg:Inactive": {
        $extendFromVariant: "betBoost:Active",
        root: {
            opacity: 0.3,
            cursor: "default",
        },
    },
    "ghostLegSelection:Active": {
        root: {
            $extendFromVariant: "_bonus",
            color: "$white",
            backgroundColor: "$purple700",
            display: "flex",
            alignItems: "center",
            lineHeight: "12px",
        },
    },
    "betBoost:Inactive": {
        $extendFromVariant: "betBoost:Active",
        root: {
            opacity: 0.3,
        },
    },
    "betBoost:Forefeited": {
        $extendFromVariant: "betBoost:Inactive",
        root: {
            textDecoration: "line-through",
        },
    },
    "earlyWin:Active": {
        root: {
            $extendFromVariant: "_bonus",
            marginRight: "auto",
            cursor: "default",
            color: "$white",
            backgroundColor: "$purple700",
        },
    },
    "earlyWin:Inactive": {
        $extendFromVariant: "earlyWin:Active",
        root: {
            backgroundColor: "rgba(146, 99, 243, 0.16)",
        },
    },
    "earlyWin:Forefeited": {
        $extendFromVariant: "earlyWin:Inactive",
        root: {
            textDecoration: "line-through",
        },
    },
    learnMore: {
        root: {
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: "4px",
            padding: 0,
            border: 0,
            fontWeight: 400,
            fontSize: "10px",
            lineHeight: "16px",
            color: "$gray400",
            backgroundColor: "transparent",
            textDecoration: "underline",
            cursor: "pointer",
        }
    },
    viewPicks: {
        root: {
            maxHeight: "24px",
            minWidth: "90px",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "14px",
            textTransform: "uppercase",
            margin: "0 16px 0 0",
            paddingTop: "2px",
            paddingRight: "8px",
            paddingBottom: "$s0",
            paddingLeft: "12px",
            borderWidth: 0,
            borderRadius: "34px",
            cursor: "pointer",
        }
    },
    "viewPicks:Active": {
        $extendFromVariant: "viewPicks",
        root: {
            color: "$white",
            backgroundColor: "$gray600",
        }
    },
    "viewPicks:Inactive": {
        $extendFromVariant: "viewPicks",
        root: {
            color: "$gray300",
            backgroundColor: "$gray700",
        }
    },
    icon: {
        root: {
            padding: 0,
            border: 0,
            backgroundColor: "transparent",
            cursor: "pointer",
        }
    }
};
export { buttonVariants };
//# sourceMappingURL=button.js.map